// UWAGA: Wykorzystane w OPAC
import Noty from "noty";
// For cable channels updates and flash_messages_controller.js
window.flash_message = (text, type) => {
  return new Noty({
    text: `<div class="alert alert-${type} m-0" role="alert">${text}</div>`,
    theme: "bs5",
    timeout: 3500
  })
}
